<template>
    <entity-reader entity="rumour" :id="id" :use-sharing="false">
        <template v-slot:[`reader`]="{ doc }">
            <label-value name="Name" :value="doc.name" />
            <label-value name="Rumour Type" :value="rumourType(doc.rumourTypeText)" />
            <label-value-html name="Description" :value="doc.description" :html="true" />
        </template>
    </entity-reader>
</template>
<script>
import EntityReader from '../../components/EntityRead'
import LabelValueRender from '../../components/LabelValueRender'
import LabelValueHtmlRender from '../../components/LabelValueHtmlRender'
export default {
    name: 'RumourReader',
    components: {
        'entity-reader': EntityReader,
        'label-value': LabelValueRender,
        'label-value-html': LabelValueHtmlRender,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
    },
    methods: {
        rumourType(rumourTypeText) {
            return rumourTypeText ? this.$options.filters.spacesBeforeCaps(rumourTypeText) : ''
        },
    },
}
</script>
